'use client'

import { Pagination } from 'flowbite-react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

export default function AppPagination({ totalPages, onServer = false }: {
  totalPages: number
  onServer?: boolean
}) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { replace } = useRouter()
  const currentPage = Number(searchParams.get('page')) || 1

  const handlePageChange = (pageNumber: number | string) => {
    const params = new URLSearchParams(searchParams)
    params.set('page', pageNumber.toString())

    if (onServer) {
      replace(`${pathname}?${params.toString()}`)
    } else {
      window.history.replaceState(null, '', `?${params.toString()}`)
    }
  }

  return (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={handlePageChange}
      showIcons
      previousLabel={''}
      nextLabel={''}
    />
  )
}
